import React from "react";

export const selectOpts = [
  { key: -1, value: -1, label: "不限制節點數" },
].concat(
  [...Array(8).keys()].map((_, idx) => ({
    key: (idx + 1) * 250,
    value: (idx + 1) * 250,
    label: `${(idx + 1) * 250}`,
  }))
);
